// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"691":"9a4b4153","776":"9a4b4153"}[chunkId] + ".chunk.css";
};